import React from "react";
import SectionBgImg from "../components/SectionBgImg";
import NumberedHeading from "../components/NumberedHeading";
import { HiOutlineAcademicCap } from "react-icons/hi";
import { useRecoilState } from "recoil";
import { detailedResultState } from "../../../utils/recoil";
import { useTranslation } from "react-i18next";

const Dynamics = () => {
  const [data] = useRecoilState(detailedResultState);
  const { t } = useTranslation("result");
  return (
    <div className="py-20 md-max:py-6">
      <NumberedHeading
        number={"3"}
        title={t("relationshipDynamics")}
        className={"px-[20rem] md-max:px-[1rem]"}
      />
      <div className="my-10 px-[20rem] md-max:px-[1rem] relative">
        <SectionBgImg className={"top-1/2 -translate-y-1/2"} />
        <div className="bg-white shadow-xl z-10 relative rounded-xl p-5 grid grid-cols-2 md-max:grid-cols-1 gap-x-5 gap-y-6">
          {data?.relationships?.dynamics?.slice(0,4)?.map((item, index) => (
            <div
              key={index}
              className="col-span-1 flex flex-col items-center bg-[#F1F7FF] text-center gap-4 px-9 py-10 rounded-xl"
            >
              <HiOutlineAcademicCap size={32} className="text-primary-blue" />
              <p className="text-2xl md-max:text-base font-light">
                {item?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dynamics;
